import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
    selector: 'app-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    standalone: false
})
/**
 * Minimal confirmation dialog reused for delete actions and other operations
 * that require an explicit user acknowledgement.
 */
export class ConfirmationDialogComponent {


  constructor(public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogModel) {
                dialogRef.disableClose = true;
  }

  onCancel() {
    this.dialogRef.close(false);
  }

  onConfirm() {
    this.dialogRef.close(true);
  }
}

/**
 * View model for the reusable confirmation dialog.
 */
export class ConfirmDialogModel {
  private _confirmText: string = "OK";
  private _cancelText: string = "Cancel";
  private _cancelColor: "accent" | "warn" | "primary" | "" = "";
  private _confirmColor: "accent" | "warn" | "primary" | "" = "";

  constructor(public title: string, public message: string) {
  }

  get cancelColor(): "accent" | "warn" | "primary" | "" {
    return this._cancelColor;
  }

  set cancelColor(value: "accent" | "warn" | "primary" | "") {
    this._cancelColor = value;
  }

  get confirmColor(): "accent" | "warn" | "primary" | "" {
    return this._confirmColor;
  }

  set confirmColor(value: "accent" | "warn" | "primary" | "") {
    this._confirmColor = value;
  }

  get cancelText(): string {
    return this._cancelText;
  }

  set cancelText(value: string) {
    this._cancelText = value;
  }

  get confirmText(): string {
    return this._confirmText;
  }

  set confirmText(value: string) {
    this._confirmText = value;
  }

  public static forDelete(type: string, identifier: string): ConfirmDialogModel {
    // Centralize the delete wording so all destructive actions stay consistent.
    const dialogData = new ConfirmDialogModel("Deletion confirmation", `Please confirm you want to delete ${type} ${identifier}. This action cannot be undone.`)
    dialogData.confirmColor = "warn";
    dialogData.confirmText = "Delete";
    dialogData.cancelText = "Cancel";
    return dialogData;
  }
}
